import { loadDraft } from "./intake-draft"
import { listWorkspaces } from "./storage"
import { incidentTypeLabel } from "./intake"

export interface ResumeTarget {
  kind: "incident" | "draft"
  href: string
  label: string
  updatedAt?: string
}

/** What this browser has saved that the person can pick back up: the newest incident, else a started intake. */
export function findResume(): ResumeTarget | null {
  const w = listWorkspaces()[0]
  if (w) return { kind: "incident", href: `/incident?id=${encodeURIComponent(w.id)}`, label: incidentTypeLabel(w.intake.incidentType), updatedAt: w.updatedAt }
  const d = loadDraft()
  if (d && d.intake.incidentType) return { kind: "draft", href: "/start", label: incidentTypeLabel(d.intake.incidentType) }
  return null
}
